<template>
  <details style="margin-top: 0.5rem; font-size: 13px;">
    <summary><strong>Ver instrucciones para importar</strong></summary>

    <div style="margin-top: 1rem; font-size: 13px;">
      <strong v-if="importType === 'initial_load'">Instrucciones de carga inicial:</strong>
      <strong v-else>Instrucciones para agregar o actualizar:</strong>

      <ul style="padding-left: 1.2rem; margin-top: 0.5rem;">
        <template v-if="importType === 'initial_load'">
          <li>Esta opción crea invitados nuevos.</li>
          <li>No actualiza registros existentes.</li>
          <li>Cada fila representa un invitado.</li>
          <li>No debes modificar los nombres de columnas de la plantilla.</li>
          <li>Los campos obligatorios deben contener información válida.</li>
          <li>Los campos opcionales pueden dejarse vacíos.</li>
          <li>Los posibles duplicados se mostrarán durante la validación.</li>
          <li>El archivo debe validarse antes de poder importarlo.</li>
          <li>Campos obligatorios: Nombre, Apellidos, Apodo, WhatsApp e Invitados.</li>
          <li>La plantilla de carga inicial incluye: Nombre, Apellidos, Apodo, WhatsApp e Invitados.</li>
        </template>

        <template v-else>
          <li>Esta opción puede crear invitados nuevos y actualizar existentes.</li>
          <li>El sistema utiliza identificadores para localizar invitados existentes.</li>
          <li>Cuando no se encuentre coincidencia, se creará un invitado nuevo.</li>
          <li>Cuando se encuentre coincidencia válida, se actualizará el invitado.</li>
          <li>Las coincidencias ambiguas se reportan como error.</li>
          <li>No debes modificar los encabezados de la plantilla.</li>
          <li>El archivo debe validarse antes de poder importarlo.</li>
          <li>Nombre, WhatsApp e Invitados son campos importantes para evitar errores.</li>
        </template>
      </ul>
    </div>
  </details>
</template>

<script>
export default {
  name: 'ImportInstructions',
  props: {
    importType: {
      type: String,
      default: 'initial_load'
    }
  }
}
</script>
